import {AttachmentFile} from '@hconnect/common/types'
import {dataTestId} from '@hconnect/uikit/src/common'
import {Column, DataTable} from '@hconnect/uikit/src/lib2'
import moment from 'moment'
import React, {useMemo} from 'react'
import {type CellValue} from 'read-excel-file'

import {useReadSalesForecastExcel} from '../../../hooks'

interface ExcelPreviewProps {
  file: AttachmentFile
}

export const ExcelPreview: React.FC<ExcelPreviewProps> = ({file}) => {
  const {data: parsedExcelData, isLoading: isReading} = useReadSalesForecastExcel(file)

  const formatColumnName = (value: CellValue) => {
    if (value === null || value === undefined) return '-'
    if (value instanceof Date) return moment(value).format('MMMM')
    return String(value)
  }

  const tableColumns: Column<Record<string, CellValue>>[] = useMemo(() => {
    if (parsedExcelData && parsedExcelData.length > 0) {
      return parsedExcelData[0].map((value, index) => ({
        key: `column-${index}`,
        label: formatColumnName(value)
      }))
    }
    return []
  }, [parsedExcelData])

  const tableData = useMemo(
    () =>
      parsedExcelData?.slice(1).map((row, index) => ({
        rowIndex: String(index),
        ...row.reduce<Record<string, CellValue>>(
          (acc, value, idx) => ({...acc, [`column-${idx}`]: value}),
          {}
        )
      })),
    [parsedExcelData]
  )

  return (
    <DataTable
      {...dataTestId('sales_forecast_excel_preview')}
      columns={tableColumns}
      data={tableData ?? []}
      keyExtractor={(row) => row.rowIndex}
      loading={isReading}
      tableContainerSx={{height: '80vh', overflowY: 'scroll'}}
    />
  )
}
